import React, { useState } from 'react'
import injectSheet from 'react-jss'
import styles from './actions.styles'
import Button from 'pobble-components/dist/button'
import ContributionModal from './contribution-modal/contribution-modal.container'

const Actions = ({ classes, sidebarOpen, onOpenSidebar, onCloseSidebar }) => {
  const [openModal, setModalVisibility] = useState(false)
  return (
    <div className={classes.container}>
      <Button
        secondary
        tall
        action={!sidebarOpen ? onOpenSidebar : onCloseSidebar}
        className={classes.discussionButton}>
        {!sidebarOpen ? 'Show discussion' : 'Hide discussion'}
      </Button>
      <Button tall action={() => setModalVisibility(true)}>
        Contribute
      </Button>
      <ContributionModal
        isOpen={openModal}
        onClose={() => setModalVisibility(false)}
      />
    </div>
  )
}

export default injectSheet(styles)(Actions)
